export default async ({ route, redirect, req }) => {
    if (process.client) return;

    const host = req?.headers?.host?.toLowerCase() || '';
    const isHomePage = route && route.path === '/';

    if (host === 'www.weeeye.com' && isHomePage) {
        return redirect('/aichat');
    }
};
